module.exports = __webpack_public_path__ + "static/img/l_sx.e7d717c4.png";